function ChartFormValidator () {

	var submitBtn = document.getElementsByClassName('cart__submit');
  	var cartForm = document.getElementsByClassName('cart');
  	var noteField = document.getElementById('CartSpecialInstructions');
  	var deliveryDateButtons = document.getElementsByClassName('delivery_time_option');
  	var dateField = document.getElementById('deliveryDate');
  	var deliveryTimeColumn = document.getElementById('deliveryTimeColumn');
  	var deliveryTimeSelected = '';
  	var validators = [];
  	var _self = this;
  
  submitBtn[0].addEventListener('click', function (e) {
    
    if(!validateForm()){
    	e.preventDefault();
    }
    
  	//validateForm();
  });
  
  _self.removeDateFromNoteField = function () {
    
    if(noteField.value !== ''){
      
  		noteField.value = noteField.value.replace(/(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}/g, '');
      	noteField.value = noteField.value.replace(' - 11am - 3pm', '');
      	noteField.value = noteField.value.replace(' - 3pm - 7pm', '');
      	noteField.value = noteField.value.replace('\nSelected delivery: ','')
  	}
  }
  	
  
  var validateForm = function () {
  
    validators = [];
    
    validators.push(checkDateSelected());
    validators.push(checkTimeSelected());
    
    
    if(formValid()){
      
      	//addDeliveryTimeToNote();
      	//cartForm[0].submit();
      
      return true;
    }
    
    return false;
  }
  
  var formValid = function () {
  
  	var valid = true;
    
    console.log(validators);
    
    for(var i = 0; i < validators.length; ++i){
    
      if(validators[i] === false){
        
        valid = false;
      }
    }
  
    return valid;
  }
  
  var addDeliveryTimeToNote = function () {
  
    var originalValue = noteField.value;
    
    noteField.value = originalValue + '\nSelected delivery: ' + dateField.value + ' - ' + deliveryTimeSelected;
  }
  
  var checkTimeSelected = function () {
  
    var valid = false;
    
  	for(i = 0; i < deliveryDateButtons.length; ++i ){
    	
      if(deliveryDateButtons[i].checked){
        
        deliveryTimeSelected = deliveryDateButtons[i].value;
      	valid = true;
        break;
      } 
    }
    
    if(valid === false){
    	deliveryTimeColumn.classList.add('error');
    }
    
    
    
    return valid;
  }
  
  var checkDateSelected = function() {
  
    var valid = true;
    
    if (dateField.value === '') {
      
      	valid = false;
     	dateField.classList.add('error');
      	document.getElementById('deliveryLabel').classList.add('error');
    }
    
    
    return valid;
  }
}


window.onload = function () {

  var chartFormValidator = new ChartFormValidator();
  //chartFormValidator.removeDateFromNoteField();
 
}